import supportModule from '../supportModule';
import { authenticatedUser } from 'header-scripts';

function supportFormController(
  $log,
  $q,
  $scope,
  supportService,
  modalService,
  languageResource,
  regexService,
  captchaV2Constants
) {
  'ngInject';

  function resetForm() {
    $scope.supportTicket = {};
    $scope.$on('onPageMetaDataInit', function () {
      $scope.supportTicket.username = $scope.accountContent.userInfo.data.Name;
    });
    $scope.supportTicket.name = '';
  }

  $scope.emailError = function () {
    return (
      !$scope.emailFocus &&
      $scope.supportForm.email.$dirty &&
      ($scope.supportForm.email.$error.required || $scope.supportForm.email.$error.pattern)
    );
  };

  $scope.emailConfirmError = function () {
    return (
      !$scope.emailConfirmFocus &&
      $scope.supportForm.emailConfirm.$dirty &&
      $scope.supportForm.emailConfirm.$error.pattern
    );
  };

  $scope.submit = function (form, captchaData) {
    $scope.formSubmitting = true;

    if (typeof $scope.supportTicket.username === 'undefined') {
      showInvalidUsernameModal(form, captchaData);
    } else {
      supportService.checkValidUsername($scope.supportTicket.username).then(
        function (response) {
          if (!(response.usernames && response.usernames[0] === $scope.supportTicket.username)) {
            showInvalidUsernameModal(form, captchaData);
          } else if (
            authenticatedUser.isAuthenticated &&
            $scope.supportTicket.username !== $scope.accountContent.userInfo.data.Name
          ) {
            showMismatchUsernameModal(form, captchaData);
          } else {
            sendSupportTicketRequest(form, captchaData);
          }
        },
        function () {
          $scope.usernameErrorMessage = '';
        }
      );
    }
  };

  $scope.captchaPassed = function (captchaData) {
    sendSupportTicketRequest($scope.supportForm, captchaData);
  };

  $scope.captchaFailed = function () {
    modalService.open({
      titleText: languageResource.get('Heading.Dialog.ErrorWithoutContext'),
      bodyText: languageResource.get('Response.Dialog.ErrorWithoutContext'),
      neutralButtonText: languageResource.get('Action.Dialog.OK')
    });
  };

  function isNullOrWhiteSpace(input) {
    return !input || !input.trim();
  }

  function sendSupportTicketRequest(form, captchaData) {
    const ticket = $scope.supportTicket;
    const supportTicket = {
      name: isNullOrWhiteSpace(ticket.name) ? 'Guest' : ticket.name,
      email: ticket.email,
      emailConfirm: ticket.emailConfirm,
      username: ticket.username,
      message: ticket.message,
      mainCategory: ticket.mainCategory.mainCategory.name,
      subCategory: ticket.subCategory,
      deviceType: ticket.deviceType,
      ageCategory: $scope.userAge13AndOver ? 'Age13AndOver' : 'AgeUnder13'
    };

    // this adds captcha token and captcha provider fields to the request
    // if captchaData is defined (it's safe if captchaData is undefined or null)
    Object.assign(supportTicket, captchaData);

    supportService.submitForm(supportTicket, $scope.pageMetaData.submitFormUrl).then(
      function (result) {
        if (result.success) {
          form.$setPristine();
          form.$setSubmitted();
          resetForm();
          modalService.open({
            titleText: languageResource.get('Heading.Dialog.RequestReceived'),
            bodyText: languageResource.get('Response.Dialog.RequestReceived'),
            neutralButtonText: languageResource.get('Action.Dialog.OK')
          });
        } else {
          let dxBlob;
          let captchaId = '';
          if (result.ErrorCode === 'CAPTCHA') {
            if (result.FieldData != null) {
              try {
                captchaData = JSON.parse(result.FieldData);
                dxBlob = captchaData.dxBlob;
                captchaId = captchaData.unifiedCaptchaId;
              } catch (e) {
                // backward compatible with old version that returns string only.
                dxBlob = result.FieldData;
              }
            }
            $scope.captchaInputParams = { unifiedCaptchaId: captchaId, dataExchange: dxBlob };
            $scope.captchaActivated = true;
            $scope.formSubmitting = false;
            return;
          }

          modalService.open({
            titleText: languageResource.get('Heading.Dialog.ErrorWithoutContext'),
            bodyText: result.message,
            neutralButtonText: languageResource.get('Action.Dialog.OK')
          });
        }
        $scope.formSubmitting = false;
      },
      function () {
        modalService.open({
          titleText: languageResource.get('Heading.Dialog.ErrorWithoutContext'),
          bodyText: languageResource.get('Response.Dialog.ErrorWithoutContext'),
          neutralButtonText: languageResource.get('Action.Dialog.OK')
        });
        $scope.formSubmitting = false;
      }
    );
  }

  function showInvalidUsernameModal(form, captchaData) {
    const modal = modalService.open({
      titleText: languageResource.get('Heading.Dialog.InvalidUsername'),
      bodyText: languageResource.get('Response.Dialog.InvalidUsername'),
      actionButtonShow: true,
      actionButtonText: languageResource.get('Action.Dialog.Send'),
      neutralButtonText: languageResource.get('Action.Dialog.Cancel')
    });
    modal.result.then(
      function () {
        sendSupportTicketRequest(form);
      },
      function () {
        // User Editing form
        $scope.formSubmitting = false;
      }
    );
  }

  function showMismatchUsernameModal(form, captchaData) {
    const modal = modalService.open({
      titleText: languageResource.get('Heading.Dialog.MismatchedUsername'),
      bodyText: languageResource.get('Response.Dialog.MismatchedUsername'),
      actionButtonShow: true,
      actionButtonText: languageResource.get('Action.Dialog.Send'),
      neutralButtonText: languageResource.get('Action.Dialog.Cancel')
    });
    modal.result.then(
      function () {
        sendSupportTicketRequest(form);
      },
      function () {
        // User Editing form
        $scope.formSubmitting = false;
      }
    );
  }

  $scope.init = function init() {
    resetForm();
    $scope.regexData = {};
    regexService.getEmailRegex().then(function (data) {
      if (data) {
        $scope.regexData.email = data.Regex;
      }
    });
    $scope.captchaActionTypes = captchaV2Constants.captchaActionTypes;
    $scope.captchaActivated = false;
    $scope.captchaReturnTokenInSuccessCb = true;

    $scope.formSubmitting = false;
  };

  $scope.init();
}

supportModule.controller('supportFormController', supportFormController);

export default supportFormController;
